import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldBasicAccountPaymentRun: false,
    basicAccountPaymentUrl: '',
    shouldMakeBasicAccountPaymentVoid: false,
    transactionIdToCancel: '',
    isLoading: false
};

export const basicAccountSlice = createSlice({
    name: 'basicAccount',
    initialState,
    reducers:{
        setShouldBasicAccountPaymentRun : (state, action) => {
            state.shouldBasicAccountPaymentRun = action.payload
        },
        setTransactionIdToCancel: (state, action) =>
        {
            state.transactionIdToCancel = action.payload
        },
        setShouldMakeBasicAccountPaymentVoid: (state, action) => 
        {
            state.shouldMakeBasicAccountPaymentVoid = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'startCreditCardPayment')
                {
                    state.basicAccountPaymentUrl = action.payload.response.redirectURL
                    state.shouldBasicAccountPaymentRun = true
                }
                else if(action.payload.endpoint === 'cancelCreditCardPayment')
                {
                    state.shouldBasicAccountPaymentRun = false
                }           
            })
    },
})
export const { setShouldBasicAccountPaymentRun,setTransactionIdToCancel, setShouldMakeBasicAccountPaymentVoid } = basicAccountSlice.actions;

export const selectBasicAccountState = (state) => state.basicAccount;

export default basicAccountSlice.reducer;

